import React, { useEffect, useState } from "react"
import { Row, Col, Space, Typography, Button } from "antd"
import styled from "styled-components"
import HeroImage from "../../images/landing/hero-product.png"
import { getLandingStats } from "../../services/api"

const { Title } = Typography

const Container = styled.div`
	margin-top: 50px;
	text-align: center;
	padding: 20px;
`

const HeroHeader = styled.h1`
	font-size: 3em;
	line-height: 1.4em;
	font-weight: bold;
	margin-bottom: 0;
`

const HeroContainer = styled.div`
	padding: 20px 50px;
	max-width: 1000px;

	@media (max-width: 768px) {
		padding: 20px 0;
	}
`

const StyledH2 = styled.h2`
	font-weight: bold;
	font-size: 30px;
	margin-bottom: 0;
`
const StyledButton: typeof Button = styled(Button)`
	font-weight: bold;
	padding: 0.1px 20px !important;
`

const statistics = [
	{
		key: "1",
		title: "Job Seekers",
		value: 58923,
	},
	{
		key: "2",
		title: "Employers Registered",
		value: 1229,
	},
	{
		key: "3",
		title: "Job Listings",
		value: 8726,
	},
	{
		key: "4",
		title: "Applications",
		value: 148293,
	},
]

const Hero: React.FC = () => {
	const [stats, setStats] = useState(statistics)

	useEffect(() => {
		async function getData() {
			const stats = await getLandingStats()
			if (stats) {
				setStats(previousStats => {
					previousStats[0].value = stats.jobSeekers
					previousStats[1].value = stats.employers
					previousStats[2].value = stats.jobListings
					previousStats[3].value = stats.applications
					return previousStats
				})
			}
		}

		getData()
	}, [])

	return (
		<Container>
			<HeroHeader>Hire in 24 hours</HeroHeader>
			<p>
				Post a job and sit back. We will bring you hand-picked
				candidates in a matter of minutes.
			</p>
			<Space size={"middle"}>
				<StyledButton
					href="/login"
					type="primary"
					size="large"
					shape="round"
				>
					Post a Job
				</StyledButton>
				<StyledButton
					href="#contact"
					type="primary"
					size="large"
					shape="round"
					ghost
				>
					Book a Demo
				</StyledButton>
			</Space>

			<Row className="mt-100" justify="center">
				<Col span={22} className="mb-20">
					<Title level={4}>
						What are you waiting for? There are already
					</Title>
				</Col>
			</Row>

			<Row justify="center">
				{stats.map(stat => {
					return (
						<Col span={12} md={{ span: 3 }} key={stat.key}>
							<div style={{ textAlign: "center" }}>
								<StyledH2>{stat.value}</StyledH2>
								<span>{stat.title}</span>
							</div>
						</Col>
					)
				})}
			</Row>

			<Row justify="center">
				<HeroContainer>
					<img src={HeroImage} style={{ width: "100%" }} />
				</HeroContainer>
			</Row>
		</Container>
	)
}

export default Hero
